import { render, staticRenderFns } from "./AllCustomers.vue?vue&type=template&id=eb99ae5a&scoped=true&"
import script from "./AllCustomers.vue?vue&type=script&lang=js&"
export * from "./AllCustomers.vue?vue&type=script&lang=js&"
import style0 from "./AllCustomers.vue?vue&type=style&index=0&id=eb99ae5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb99ae5a",
  null
  
)

export default component.exports